import { render, staticRenderFns } from "./CataloguePage.vue?vue&type=template&id=a94d7892"
import script from "./CataloguePage.vue?vue&type=script&lang=js"
export * from "./CataloguePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports